import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home')
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: () => import('@/views/Contacts')
  },
  {
    path: '/price-change',
    name: 'PriceChange',
    component: () => import('@/views/NewPrice')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
